import React, {useEffect} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import useZibi from "../../zibi/UseZibi";

const AuthMiddleware = ({children}) => {
    const location = useLocation();
    const [, s_initialRoutePath] = useZibi('initialRoutePath');

    useEffect(() => {
        if (location.pathname !== "/") {
            s_initialRoutePath(location.pathname + location.search);
        }
    }, []);

    const [isLoggedIn] = useZibi('isLoggedIn');

    if (!isLoggedIn) {
        return <Navigate to="/login" state={{from: location}} replace/>;
    }

    return children;
};

export default AuthMiddleware;